import React, { ChangeEvent } from "react";
import "./TextArea.css";

interface TextAreaProps {
  content: string;
  label?: string;
  name: string;
  placeholder?: string;
  onChange: (value: ChangeEvent<HTMLTextAreaElement>) => void;
}

const TextArea: React.FC<TextAreaProps> = ({
  name,
  label,
  content,
  placeholder,
  onChange,
}) => {
  return (
    <div className="text-area-input">
      <label htmlFor={name}>{label}</label>
      <textarea
        className="text-area"
        id={name}
        placeholder={placeholder}
        name={name}
        value={content}
        onChange={onChange}
      />
    </div>
  );
};

export default TextArea;
